import { API_VERSION } from "./constants";
import { http } from "./httpServices";

export const uploadAttachment = (data) => {
  const formData = new FormData();
  formData.append("file", data);
  return http.post(API_VERSION + "/encode/uploadAttachment", formData);
};

export function applyBizTripLeave(data) {
  return http.post(API_VERSION + "/businesstrip/leave", data);
}

export function getLeaveList(params) {
  return http.get(API_VERSION + "/businesstrip/leaveDetails", {
    params,
  });
}

export function addBizBooking(data) {
  return http.post(API_VERSION + "/booking/businessTrip", data);
}

export function updateBizBooking(data, id) {
  return http.put(API_VERSION + `/booking/businessTrip/${id}`, data);
}

export function getUpcomingTrip() {
  return http.get(API_VERSION + "/businesstrip/upcoming");
}

export function cancelBizBooking(id, data) {
  return http.put(`${API_VERSION}/businesstrip/cancelBusinessTrip/${id}`, data);
}

export const uploadLeaveAttachment = (data) => {
  const formData = new FormData();
  formData.append("file", data);
  return http.post(API_VERSION + "/businesstrip/uploadAttachment", formData);
};
